import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, {
  DemoSliderControl,
  DemoRadioControl,
} from '@/components/Demo';

import Snippet from './Snippet';
import OutputWrapper from './OutputWrapper';

function RemPaddingDemo() {
  return (
    <Demo
      id="rem-padding-demo"
      initialValues={{
        fontSize: 100,
        unit: 'px',
      }}
      outputWrapper={OutputWrapper}
      controls={[
        <DemoSliderControl
          key="fontSize"
          id="fontSize"
          label="Default font size"
          min={100}
          max={250}
          previewRenderer={(val) => `${val}%`}
        />,
        <DemoRadioControl
          key="unit"
          id="unit"
          label="Padding unit"
          options={['px', 'rem']}
        />,
      ]}
      controlPosition="top"
    >
      {({ fontSize, unit }) => (
        <OuterWrapper>
          <Wrapper>
            <DisplayedPadding
              style={{
                padding: unit === 'rem' ? (fontSize / 100) * 32 : 32,
              }}
            >
              <Paragraph
                style={{
                  fontSize: (fontSize / 100) * 16,
                }}
              >
                This is a paragraph containing many words in a
                specific, intentional order.
              </Paragraph>
            </DisplayedPadding>
          </Wrapper>

          <Snippet
            code={generateCodeSnippet({ unit })}
            minCodeHeight="9.5rem"
          />
        </OuterWrapper>
      )}
    </Demo>
  );
}

function generateCodeSnippet({ unit }: { unit: 'px' | 'rem' }) {
  return `.wrapper {
  font-size: 1rem;
  padding: ${unit === 'px' ? '32px' : '2rem'};
}`;
}

const OuterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Wrapper = styled.div`
  width: 100%;
  padding: 16px;

  @media ${BREAKPOINTS.smAndLarger} {
    padding: 32px;
    margin-bottom: 0;
  }
`;

const DisplayedPadding = styled.div`
  background-color: #c9ddbb;
`;

const Paragraph = styled.p`
  background: white;
  text-align: left;
`;

export default RemPaddingDemo;
